import { render } from "./TargetEditorDialog.vue?vue&type=template&id=126cb72c"
import script from "./TargetEditorDialog.vue?vue&type=script&lang=ts"
export * from "./TargetEditorDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script